let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page001_game1/img/bcg.jpg',
    pos: {
      x: 183,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    // {
    //   src: 'games/page001_game1/audio/s2_1.mp3',
    //   audioConfig: {
    //     autoplay: false,
    //     loop: false,
    //     volume: 1,
    //   },
    //   iconConfig: {
    //     fill: 'none',
    //   },
    //   width: '40px',
    //   height: '40px',
    //   pos: {
    //     y: 115,
    //     x: 256,
    //   },
    //   unit: 'px',
    // },
    // {
    //   src: 'games/page001_game1/audio/s2_2.mp3',
    //   audioConfig: {
    //     autoplay: false,
    //     loop: false,
    //     volume: 1,
    //   },
    //   iconConfig: {
    //     fill: 'none',
    //   },
    //   width: '40px',
    //   height: '40px',
    //   pos: {
    //     y: 115,
    //     x: 1010,
    //   },
    //   unit: 'px',
    // },
    // {
    //   src: 'games/page001_game1/audio/s2_3.mp3',
    //   audioConfig: {
    //     autoplay: false,
    //     loop: false,
    //     volume: 1,
    //   },
    //   iconConfig: {
    //     fill: 'none',
    //   },
    //   width: '40px',
    //   height: '40px',
    //   pos: {
    //     y: 584,
    //     x: 256,
    //   },
    //   unit: 'px',
    // },
    // {
    //   src: 'games/page001_game1/audio/s2_4.mp3',
    //   audioConfig: {
    //     autoplay: false,
    //     loop: false,
    //     volume: 1,
    //   },
    //   iconConfig: {
    //     fill: 'none',
    //   },
    //   width: '40px',
    //   height: '40px',
    //   pos: {
    //     y: 584,
    //     x: 1010,
    //   },
    //   unit: 'px',
    // },
    {
      src: 'games/page001_game1/audio/Track_11_Story_2_Colours.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: -17,
        x: 854,
      },
      unit: 'px',
    },
  ],
  imageRedirect: [
    {
      imgSrc: 'games/page001_game1/img/powiekszGrafike.png',
      routerPush: '/karta/1/s2',
      cssStyle: {
        top: '48.2%',
        left: '46.9%',
      },
    },
    {
      imgSrc: 'games/page001_game1/img/powiekszGrafike.png',
      routerPush: '/karta/1/s2/1',
      cssStyle: {
        top: '48.2%',
        left: '84%',
      },
    },
    {
      imgSrc: 'games/page001_game1/img/powiekszGrafike.png',
      routerPush: '/karta/1/s2/2',
      cssStyle: {
        top: '100.2%',
        left: '46.9%',
      },
    },
    {
      imgSrc: 'games/page001_game1/img/powiekszGrafike.png',
      routerPush: '/karta/1/s2/3',
      cssStyle: {
        top: '100.2%',
        left: '84%',
      },
    },
  ],
};

export default elements;
